<template>
    <a-modal title="修改终点属性"
             :width="620"
             :visible="visible"
             :maskClosable="false"
             @ok="onOk"
             @cancel="onCancel">
        <a-form-model ref="form" :model="formData" class="pick-100 form-input about">
            <a-row>
                <a-col :span="23">
                    <a-form-model-item label="终点名称" prop="name" :rules="{ required: true, message: '请输入终点名称'}">
                        <a-input v-model="formData.name" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-space size="large">
              <WFIconSelector @change="onChangeIcon" />
            </a-space>
        </a-form-model>
    </a-modal>
</template>
<script>
import WFIconSelector from './WFIconSelector'

export default {
  components: {
    WFIconSelector
  },
  props: {
  },
  data () {
    return {
      formData: {
        name: ''
      },
      wfNode: null,
      visible: false
    }
  },
  methods: {
    show (wfNode) {
      this.wfNode = wfNode
      this.onRestForm()
      this.formData.name = this.wfNode.getName()
      this.visible = true
    },
    onRestForm () {
      this.formData.name = ''
    },
    onOk () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return
        }
        let data = this.formData
        this.wfNode.setName(data.name)
        this.wfNode.fixLayout()
        this.wfNode.updateXmlNode()
        this.visible = false
      })
    },
    onCancel () {
      this.visible = false
    },
    onChangeIcon (path) {
      this.wfNode.setIcon(path)
      this.onOk()
    }
  }
}
</script>
<style scoped>
</style>
